/**
 * ReportsHarvestInspectionOverallDefectPercentage
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    overallDefectPercentage?: ?number;
}

export class ReportsHarvestInspectionOverallDefectPercentage extends React.PureComponent<Props> {
    render() {
        const { overallDefectPercentage } = this.props;
        if (!overallDefectPercentage && overallDefectPercentage !== 0) {
            return null;
        }
        return `${overallDefectPercentage}%`;
    }
}

const mapStateToProps = createStructuredSelector({
    overallDefectPercentage: makeSelectReportsHarvestInspectionValue(
        'overallDefectPercentage'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionOverallDefectPercentage
);
